import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  crafts: [],
};

const getters = {
  getCrafts: (state) => state.crafts,
  getCraftById: (state) => (id) => state.crafts.find((x) => x.id == id),
};

const actions = {
  async fetchCrafts({ commit }) {
    try {
      const resp = await api.get("/crafts");
      console.log("resp:::", resp);
      if (resp.status == 200) {
        const crafts = resp.data.data;
        console.log("crafts:::", crafts);
        commit("setCrafts", crafts);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateCraft({ commit }, craft) {
    console.log("xxx:", craft);
    try {
      const id = craft.id;
      craft._method = "patch";

      const resp = await api.post(`/crafts/${id}`, craft);
      if (resp.status == 200) {
        const craft = resp.data.data;
        console.log("updated:", craft);
        commit("updateCraft", craft);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addCraft({ commit }, craft) {
    try {
      const resp = await api.post(`/crafts`, craft);

      if (resp.status == 201) {
        const craft = resp.data.data;

        commit("addCraft", craft);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteCraft({ commit }, id) {
    try {
      const resp = await api.delete(`/crafts/${id}`);

      if (resp.status == 204) {
        commit("deleteCraft", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setCrafts(state, crafts) {
    state.crafts = crafts;
  },
  updateCraft(state, craft) {
    const id = craft.id;
    const index = state.crafts.findIndex((craft) => craft.id == id);
    if (index !== -1) {
      state.crafts[index] = craft;
    }
  },
  addCraft(state, craft) {
    state.crafts.unshift(craft);
  },

  deleteCraft(state, id) {
    const index = state.crafts.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.crafts.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
